<template>
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <spinner v-show="!isLoaded"></spinner>
      <card v-show="isLoaded" card-body-classes="table-full-width" no-footer-line>
        <h4 slot="header" class="card-title">Liste des clients</h4>
        <div slot="header" class="col-12 text-right" style="margin-bottom: 10px; margin-top: -50px">
          <input type="text" valid="true" placeholder="Recherche" @keypress="search" @keydown="search" class="MySearch form-control">
  <!--        <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="excelExport()">-->
  <!--          <span><i class="fas fa-file-csv"></i></span>-->
  <!--        </n-button>-->
  <!--        <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="openChooserColumnMenu()">-->
  <!--          <span><i class="fas fa-columns"></i></span>-->
  <!--        </n-button>-->
  <!--        <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="addArticle()">-->
  <!--          <span><i class="fas fa-plus"></i></span>-->
  <!--        </n-button>-->
        </div>
        <div class="mr-4 ml-4 mb-4">
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"></div>
          <!-- Syncfusion Table here -->
          <ejs-grid ref='customerList' id="Grid" :dataSource="tableData" :enablePersistence='false'
                    :allowReordering='true' :allowResizing='true'  :showColumnChooser='true'
                    :enableHover='false' :allowSelection='true' :allowPaging="true"
                    :allowSorting='true' :allowGrouping='false'  :editSettings='editSettings'
                    :pageSettings='pageSettings' :allowExcelExport='true' class="customer-datagrid">
            <e-columns>
<!--              <e-column field='ref' headerText='Référence' isPrimaryKey=true textAlign='Left' width=40></e-column>-->
              <e-column field='name' headerText='Nom' textAlign='Left' width=90></e-column>
<!--              <e-column field='type' headerText='Type' textAlign='Left' width=40></e-column>-->
              <e-column field='commands' headerText=''  textAlign='Center' minWidth=10 width=10 :commands='commands'></e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import Authorizable from "@/mixins/authorizable";
import Spinner from "@/components/Spinner/Circle";
import {ColumnChooser, CommandColumn, DetailRow, Edit, ExcelExport, Filter, Group, Page, Reorder, Resize, Search, Sort} from "@syncfusion/ej2-vue-grids";

export default {
  name: "CustomerList",
  mixins: [Authorizable],
  components: {
    Spinner
  },
  data() {
    return {
      isLoaded: false,
      tableData: [],
      editSettings: { allowEditing: false, allowDeleting: true },
      commands: [{ buttonOption: { cssClass: 'e-lib e-btn e-control e-flat e-icon-btn fas fa-edit', iconCss: 'e-icons', click: this.editButton} }],
      // searchOptions: {fields: ['command_number', 'customer_command_number', 'detailTemplate', 'customer']},
      pageSettings: { pageSize: 15, pageSizes: true }
    };
  },
  provide: {
    grid: [Page, Search, Sort, Filter, Group, ExcelExport, DetailRow, ColumnChooser, Resize, Reorder, Edit, CommandColumn]
  },
  mounted(){
    this.fetchData()
  },
  methods: {
    fetchData(){
      this.axios.get(process.env.VUE_APP_API_BASE_URL+`customer/list/all`).catch(error => {

      }).then( response => {
        this.tableData = response.data
        this.isLoaded =  true
      })
    },
    editButton(args){
      var rowEle = $(args.target).parents('.e-row')
      var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
      this.$refs.customerList.selectRow(rowIndex)
      var rowData = this.$refs.customerList.getSelectedRecords()[0]

      // if(!this.can('update_device')){
      this.$router.push({ name: 'Customer Form', params: {customer: rowData} })
    },
    search: function() {
      let searchText = document.getElementsByClassName('MySearch')[0].value;
      this.$refs.customerList.search(searchText);
    },
  }
}
</script>

<style scoped>

</style>